import { inject } from '@angular/core';
import { CanMatchFn, PartialMatchRouteSnapshot, Route, Router, UrlSegment } from '@angular/router';
import { readAuthState, redirectToIdentity } from './auth';
import { hasBffSession, isBffMode, redirectToBffLogin } from './bff';

export const authGuard: CanMatchFn = async (_route: Route, segments: UrlSegment[], current: PartialMatchRouteSnapshot) => {
  // Return to the URL being matched, not the one the navigation started from: a redirect earlier in the
  // table may have rewritten it, and whatever it dropped must not ride through the login. The query rides
  // the snapshot — without it /project-journey?projectId=… came back on «Проект не выбран».
  const router = inject(Router);
  const target = router.createUrlTree(['/', ...segments.map(s => s.path)], {
    queryParams: current.queryParams,
    fragment: current.fragment ?? undefined,
  });
  const returnUrl = router.serializeUrl(target);
  if (isBffMode()) {
    if (await hasBffSession()) return true;
    redirectToBffLogin(returnUrl);
    return false;
  }

  if (readAuthState()?.accessToken) return true;
  redirectToIdentity(returnUrl);
  return false;
};
